module.exports = __webpack_public_path__ + "static/media/stofferingen-48.0103baed.jpg";